// Pure helpers for the optional per-event header tagline (bilingual, single line).
// Framework-free so they unit-test like the other helpers/ modules.

export const TAGLINE_MAX_LENGTH = 100;

// Resolve which tagline string (and its lang) to show for the current locale.
// Preference: current-locale value, else the other language, else empty.
export const resolveTagline = ({ en, fr, language } = {}) => {
  const isFr = language === "fr-CA";
  const preferred = isFr ? fr : en;
  const text = (preferred || en || fr || "").trim();
  const lang = preferred ? (isFr ? "fr" : "en") : en ? "en" : "fr";
  return { text, lang };
};

// Compute the setEventTagline write payload from the editor's checkbox + input state.
// Trims values; whitespace-only counts as empty. A language that had a saved value and
// is now empty/unchecked is marked for deletion.
export const computeTaglinePayload = ({
  enChecked,
  frChecked,
  enValue,
  frValue,
  prevEn,
  prevFr
} = {}) => {
  const enText = enChecked && enValue ? enValue.trim() : "";
  const frText = frChecked && frValue ? frValue.trim() : "";
  const deleteEn = Boolean(prevEn && prevEn.length > 0) && enText.length === 0;
  const deleteFr = Boolean(prevFr && prevFr.length > 0) && frText.length === 0;
  return { enText, frText, deleteEn, deleteFr };
};
